// @ts-nocheck
import type { ItemDefinition } from '../../../../../shims/appStub';
import type { ItemMetricKey } from '../../types/binding';

function uriHasExtension(uris: string[] | undefined, ext: string): boolean {
  if (!uris?.length) {
    return false;
  }
  const suffix = ext.startsWith('.') ? ext.toLowerCase() : `.${ext.toLowerCase()}`;
  return uris.some((uri) => uri.toLowerCase().includes(suffix));
}

export function resolveSyncItemMetric(
  metric: ItemMetricKey,
  item: ItemDefinition,
): unknown | undefined {
  switch (metric) {
    case 'outEdgeCount':
      return item.itemRelationUuids?.length ?? 0;
    case 'imageCount':
      return item.imageUris?.length ?? 0;
    case 'documentCount':
      return item.documents?.length ?? 0;
    case 'categoryCount':
      return item.categories?.length ?? 0;
    case 'tagCount':
      return item.tagList?.length ?? 0;
    case 'historyEntryCount':
      return item.history?.length ?? 0;
    case 'hasSvgImage':
      return uriHasExtension(item.imageUris, '.svg');
    case 'hasPngImage':
      return uriHasExtension(item.imageUris, '.png');
    default:
      return undefined;
  }
}

export function isSyncItemMetric(metric: ItemMetricKey): boolean {
  return resolveSyncItemMetric(metric, {} as ItemDefinition) !== undefined
    || ['outEdgeCount', 'imageCount', 'documentCount', 'categoryCount', 'tagCount', 'historyEntryCount', 'hasSvgImage', 'hasPngImage'].includes(metric);
}
